import { call, put, all, takeEvery, select } from "redux-saga/effects";
import { invoiceRegistryActions } from "../actions";
import api from "../services/invoiceRegistry.service";
import { generalActions } from "../actions";
import ACTIONS from "../constants";
import { invoiceRegistryPagination } from "../selectors/invoiceRegistry.selector";
import { getProjectBudgetSummary } from "../actions/projects.actions";

function* sortInvoiceRegistries(state) {
  try {
    yield put(invoiceRegistryActions.sortInvoiceRegistryRequestAttempt.pending);
    const invoiceRegistries = yield call(
      api.sortInvoiceRegistryRequest,
      state.payload
    );
    const pagination = JSON.parse(invoiceRegistries.headers["x-pagination"]);
    const data = {
      data: invoiceRegistries.data,
      pagination: pagination,
    };
    yield put(
      invoiceRegistryActions.sortInvoiceRegistryRequestAttempt.success(data)
    );
  } catch (error) {
    yield put(
      invoiceRegistryActions.sortInvoiceRegistryRequestAttempt.error(
        error.message
      )
    );
  }
}

function* getInvoiceRegistries(state) {
  try {
    yield put(invoiceRegistryActions.getInvoiceRegistryAttempt.pending);
    const invoiceRegistry = yield call(
      api.getInvoiceRegistriesRequest,
      state.payload
    );
    const pagination = JSON.parse(invoiceRegistry.headers["x-pagination"]);
    const data = {
      data: invoiceRegistry.data,
      pagination: pagination,
    };
    yield put(invoiceRegistryActions.getInvoiceRegistryAttempt.success(data));
  } catch (error) {
    if (
      error.message ===
      `Cannot read properties of undefined (reading 'x-pagination')`
    ) {
      yield put(invoiceRegistryActions.getInvoiceRegistryAttempt.error(""));
    } else {
      yield put(
        invoiceRegistryActions.getInvoiceRegistryAttempt.error(error.message)
      );
    }
  }
}

function* createInvoiceRegistry(state) {
  try {
    yield put(invoiceRegistryActions.createInvoiceRegistryAttempt.pending);
    yield call(api.createInvoiceRegistryRequest, state.payload);
    const payload = {
      id: state.payload.parentID,
      parent: state.payload.parent,
      page: 1,
      size: state.payload.perPageItems,
    };
    if(state.payload.parent == "Project"){
      yield put(getProjectBudgetSummary({id: state.payload.parentID}));
    }
    const invoiceRegistries = yield call(api.getInvoiceRegistriesRequest,payload);
    const pagination = JSON.parse(invoiceRegistries.headers["x-pagination"]);
    const data = {
      data: invoiceRegistries.data,
      pagination: pagination,
    };
    yield put(
      invoiceRegistryActions.createInvoiceRegistryAttempt.success(data)
    );
    yield put(
      generalActions.showToast({
        title: "InvoiceRegistry saved",
        type: "success",
      })
    );
  } catch (error) {
    const errorObject = JSON.parse(JSON.stringify(error));
    if (
      errorObject.status === 500 ||
      errorObject.status === 502 ||
      errorObject === "Netwrok Error!"
    ) {
      yield put(
        invoiceRegistryActions.createInvoiceRegistryAttempt.error(
          errorObject.data
        )
      );
      yield put(
        generalActions.showToast({
          title: "Something went wrong. Please try again later.",
          type: "error",
        })
      );
    }
    if (errorObject.status === 422) {
      yield put(
        invoiceRegistryActions.createInvoiceRegistryAttempt.error(
          errorObject.data
        )
      );
    }
    if (errorObject.status === 400) {
      yield put(
        invoiceRegistryActions.createInvoiceRegistryAttempt.error(
          errorObject.data
        )
      );
      yield put(
        generalActions.showToast({
          title: errorObject.data.errors[0].message,
          type: "error",
        })
      );
    }
  }
}

function* updateInvoiceRegistry(state) {
  try {
    yield put(invoiceRegistryActions.updateInvoiceRegistryAttempt.pending);
    yield call(api.updateInvoiceRegistryRequest, state.payload);
    if(state.payload.parent == "Project"){
      yield put(getProjectBudgetSummary({id: state.payload.parentID}));
    }
    const paginat = yield select(invoiceRegistryPagination);
    const payload = {
      id: state.payload.parentID,
      parent: state.payload.parent,
      page: paginat.CurrentPage,
      size: paginat.PageSize,
    };
    const invoiceRegistries = yield call(
      api.getInvoiceRegistriesRequest,
      payload
    );
    const pagination = JSON.parse(invoiceRegistries.headers["x-pagination"]);
    const data = {
      data: invoiceRegistries.data,
      pagination: pagination,
    };
    yield put(
      invoiceRegistryActions.updateInvoiceRegistryAttempt.success(data)
    );
    yield put(
      generalActions.showToast({
        title: "InvoiceRegistry updated successfully",
        type: "success",
      })
    );
  } catch (error) {
    const errorObject = JSON.parse(JSON.stringify(error));
    if (
      errorObject.status === 500 ||
      errorObject.status === 502 ||
      errorObject === "Network Error!"
    ) {
      yield put(
        invoiceRegistryActions.updateInvoiceRegistryAttempt.error(
          errorObject.data
        )
      );
      yield put(
        generalActions.showToast({
          title: "Something went wrong. Please try again later.",
          type: "error",
        })
      );
    }
    if (errorObject.status === 422) {
      yield put(
        invoiceRegistryActions.updateInvoiceRegistryAttempt.error(
          errorObject.data
        )
      );
    }
    if (errorObject.status === 400) {
      yield put(
        invoiceRegistryActions.updateInvoiceRegistryAttempt.error(
          errorObject.data
        )
      );
      yield put(
        generalActions.showToast({
          title: errorObject.data.errors[0].message,
          type: "error",
        })
      );
    }
  }
}

function* deleteInvoiceRegistry(state) {
  try {
    yield put(invoiceRegistryActions.deleteInvoiceRegistryAttempt.pending);
    yield call(api.deleteInvoiceRegistryRequest, state.payload);
    if(state.payload.parent == "Project"){
      yield put(getProjectBudgetSummary({id: state.payload.parentID}));
    }
    const paginat = yield select(invoiceRegistryPagination);
    const payload = {
      id: state.payload.parentID,
      parent: state.payload.parent,
      page: paginat.CurrentPage,
      size: paginat.PageSize,
    };
    const invoiceRegistries = yield call(
      api.getInvoiceRegistriesRequest,
      payload
    );
    const pagination = JSON.parse(invoiceRegistries.headers["x-pagination"]);
    const data = {
      data: invoiceRegistries.data,
      pagination: pagination,
    };
    yield put(
      invoiceRegistryActions.deleteInvoiceRegistryAttempt.success(data)
    );
    yield put(
      generalActions.showToast({
        title: "InvoiceRegistry deleted",
        type: "success",
      })
    );
  } catch (error) {
    const errorObject = JSON.parse(JSON.stringify(error));
    if (
      errorObject.status === 500 ||
      errorObject.status === 502 ||
      errorObject === "Network Error!"
    ) {
      yield put(
        invoiceRegistryActions.deleteInvoiceRegistryAttempt.error(error.message)
      );
      yield put(
        generalActions.showToast({
          title: "Something went wrong. Please try again later.",
          type: "error",
        })
      );
    }
    if (errorObject.status === 422) {
      yield put(
        invoiceRegistryActions.deleteInvoiceRegistryAttempt.error(error.message)
      );
    }
    if (errorObject.status === 400) {
      yield put(
        invoiceRegistryActions.deleteInvoiceRegistryAttempt.error(error.message)
      );
      yield put(
        generalActions.showToast({
          title: errorObject.data.errors[0].message,
          type: "error",
        })
      );
    }
  }
}

function* updateInvoiceRegistryFlag(state) {
  try {
    yield put(invoiceRegistryActions.updateInvoiceRegistryFlagAttempt.pending);
    yield call(api.updateInvoiceRegistryFlagRequest, state.payload);
    yield put(
      invoiceRegistryActions.updateInvoiceRegistryFlagAttempt.success()
    );
    yield put(
      generalActions.showToast({
        title: "InvoiceRegistry flag updated successfully",
        type: "success",
      })
    );
  } catch (error) {
    yield put(
      invoiceRegistryActions.updateInvoiceRegistryFlagAttempt.error(
        error.message
      )
    );
  }
}

export default function* rootSaga() {
  yield all([
    takeEvery(ACTIONS.SORT_INVOICE_REGISTRY_CALL, sortInvoiceRegistries),
    takeEvery(ACTIONS.INVOICE_REGISTRY_CALL, getInvoiceRegistries),
    takeEvery(ACTIONS.CREATE_INVOICE_REGISTRY_CALL, createInvoiceRegistry),
    takeEvery(ACTIONS.UPDATE_INVOICE_REGISTRY_CALL, updateInvoiceRegistry),
    takeEvery(ACTIONS.DELETE_INVOICE_REGISTRY_CALL, deleteInvoiceRegistry),
    takeEvery(ACTIONS.INVOICE_REGISTRY_FLAG_CALL, updateInvoiceRegistryFlag),
  ]);
}
